import PropTypes from 'prop-types';
import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { reduxForm, reset } from 'redux-form';
import MaterialTable from '../../shared/components/material-table';
import { DEFAULT_PAGE_SIZE } from '../../shared/utils/constants';
import columns from './components/Columns';
import VaccinationFilter from './components/VaccinationFilter';
import Modal from '../../shared/components/Modal';
import VaccineApplicationInformationModal from './components/VaccineApplicationInformationModal';
import {
  vaccineListByFilter,
  vaccineListForFilter,
  vaccineRemove,
  vaccineSave,
} from '../../shared/queries/Vaccination';
import { classListActivesByFunc } from '../../shared/queries/SchoolClass';
import { studentListByFilter } from '../../shared/queries/Student';
import GraphQl from '../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import { upLoadFile } from '../../shared/utils/smartutils';
import { useSmartContext } from '../App/context/SmartProvider';

const Vaccination = (props) => {
  const { t, dispatch } = props;
  const { loggedUser } = useSmartContext();
  const [filterisOpen, setFilterIsOpen] = useState(false);
  const [lastFilter, setLastFilter] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [applyModal, setApplyModal] = useState(false);
  const [
    vaccineApplicationInformationModal,
    setVaccineApplicationInformationModal,
  ] = useState(false);
  const [vaccines, setVaccines] = useState([]);
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [data, setData] = useState();
  const [selectedDto, setSelectedDto] = useState([]);
  const [qtdeSelectedColumns, setqtdeSelectedColumns] = useState(1);

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const onFilterToggle = () => {
    setFilterIsOpen(!filterisOpen);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const toggleApplyModal = () => {
    setApplyModal(!applyModal);
  };

  const toggleVaccineApplicationInformationModal = () => {
    setApplyModal(false);
    dispatch(reset('VaccineApplicationInformationModal'));
    setVaccineApplicationInformationModal(!vaccineApplicationInformationModal);
  };

  const applyClickHandler = (rowData) => {
    const filteredApplied = rowData.filter(
      (item) => item.applicationDate === 0
    );

    setSelectedDto([...filteredApplied]);
    setqtdeSelectedColumns(rowData.length);
    toggleApplyModal();
  };

  const listVaccines = () => {
    showLoading();
    const query = vaccineListForFilter();
    GraphQl(query, {})
      .then((res) => {
        res.vaccineListForFilter = res.vaccineListForFilter.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        hideLoading();
        setVaccines(res.vaccineListForFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      });
  };

  const loadData = (filter) => {
    if (filterisOpen) {
      onFilterToggle();
    }
    showLoading();
    const query = vaccineListByFilter(filter);
    GraphQl(query, {})
      .then((res) => {
        res.vaccineListByFilter = res.vaccineListByFilter.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        hideLoading();
        setData(res.vaccineListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      });
  };

  const deleteItems = () => {
    const applicationsId = selectedDto.map((vaccine) => vaccine.applicationId);
    if (applicationsId.some((id) => id === 0)) {
      toggleDeleteModal();
      showNotificationAutoDestroy(
        'warning',
        t('notifications.attention'),
        t('notifications.no-applied-vaccines')
      );
    } else {
      toggleDeleteModal();
      showLoading();
      const removeMutation = vaccineRemove(selectedDto);
      GraphQl(removeMutation, {})
        .then(() => {
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-removed')
          );
        })
        .catch(() => {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-remove')
          );
        })
        .finally(() => {
          loadData(lastFilter);
          hideLoading();
        });
    }
  };

  const listClasses = () => {
    const query = classListActivesByFunc();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.classListActivesByFunc = res.classListActivesByFunc.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        hideLoading();
        setClasses(res.classListActivesByFunc);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      });
  };

  const listStudents = () => {
    const filter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    };
    const query = studentListByFilter(filter);
    GraphQl(query, {})
      .then((res) => {
        res.studentListByFilter = res.studentListByFilter.map((item) => ({
          ...item,
          label: item.fullName,
          value: item.id,
        }));
        hideLoading();
        setStudents(res.studentListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      });
  };
  const onFilterClickHandler = (filter) => {
    if (filter) {
      setLastFilter(filter);
      loadData(filter);
    } else if (lastFilter) {
      loadData(lastFilter);
    }
  };

  const onRemoveItemsClickHandler = (evt, rowData) => {
    setSelectedDto([...rowData]);
    setqtdeSelectedColumns(rowData.length);
    toggleDeleteModal();
  };

  const filterBuildFunction = () => (
    <VaccinationFilter
      filterToggle={onFilterToggle}
      isFiltering={filterisOpen}
      filterClick={onFilterClickHandler}
      vaccines={vaccines}
      students={students}
      classes={classes}
      lastFilter={lastFilter}
    />
  );

  const handleSubmit = async (vaccine) => {
    let uploadedFile;
    if (vaccine.file.length) {
      if (!vaccine.file[0].fileId) {
        uploadedFile = await upLoadFile(vaccine.file[0]);
      } else {
        uploadedFile = { fileId: null };
      }
    } else {
      uploadedFile = { fileId: null };
    }
    const updatedVaccines = selectedDto.map((item) => ({
      applicationId: 0,
      studentId: item.studentId,
      doseId: item.doseId,
      doseCallendarId: item.doseCallendarId,
      applicationDate: vaccine.applicationDate,
      fileId: uploadedFile && uploadedFile.fileId ? uploadedFile.fileId : null,
      appliedBy: loggedUser.name,
    }));

    toggleVaccineApplicationInformationModal();
    const query = vaccineSave(updatedVaccines);
    GraphQl(query, {})
      .then(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        loadData(lastFilter);
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
        loadData(lastFilter);
      });
  };

  const updateVaccines = (vaccine) => {
    toggleApplyModal();
    toggleVaccineApplicationInformationModal();
    showLoading();
    handleSubmit(vaccine);
  };

  useEffect(() => {
    listVaccines();
    listClasses();
    listStudents();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('vaccination.deleteModal.message').replace(
          '[?]',
          qtdeSelectedColumns
        )}
        toggle={toggleDeleteModal}
        modal={deleteModal}
        onConfirm={deleteItems}
      />
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('vaccination.applyModal.message').replace(
          '[?]',
          qtdeSelectedColumns
        )}
        toggle={toggleApplyModal}
        modal={applyModal}
        onConfirm={toggleVaccineApplicationInformationModal}
      />
      <VaccineApplicationInformationModal
        title={t('vaccination.vaccineApplicationInformationModal.title')}
        modal={vaccineApplicationInformationModal}
        toggle={toggleVaccineApplicationInformationModal}
        VaccinesReportedQuantity={qtdeSelectedColumns}
        updateVaccines={updateVaccines}
        vaccines={selectedDto}
      />

      <Container>
        <Row className="Table">
          <Col md={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    id="VaccinationSmartFilter"
                    showFilter
                    data={data}
                    isFiltering={filterisOpen}
                    filterToggle={onFilterToggle}
                    columns={columns(t)}
                    pageSize={DEFAULT_PAGE_SIZE}
                    title={t('vaccination.title')}
                    filterBuildFunction={filterBuildFunction}
                    selection
                    onApplyClick={applyClickHandler}
                    onRemoveClick={onRemoveItemsClickHandler}
                    actionsPosition="toolbarOnSelect"
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Vaccination.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'Vaccination',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(Vaccination));
